import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function Inventario() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ nombre: "", existencia: 0, minimo: 0, unidad: "pz" });
  const load = () => api.get("/inventario").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.nombre) return toast.error("Nombre requerido");
    try {
      await api.post("/inventario", { ...form, existencia: parseFloat(form.existencia) || 0, minimo: parseFloat(form.minimo) || 0 });
      toast.success("Insumo creado");
      setOpen(false); setForm({ nombre: "", existencia: 0, minimo: 0, unidad: "pz" }); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const updateExistencia = async (id, val) => {
    await api.patch(`/inventario/${id}`, { existencia: parseFloat(val) || 0 });
    load();
  };

  const bajoStock = items.filter((i) => i.existencia <= i.minimo);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center flex-wrap gap-2">
        <div><h2 className="text-3xl font-black tracking-tight">Inventario</h2><p className="text-sm text-muted-foreground mt-1">Control básico de insumos.</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button><Plus className="h-4 w-4 mr-1" />Nuevo insumo</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuevo insumo</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nombre *</Label><Input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} /></div>
              <div className="grid grid-cols-3 gap-2">
                <div><Label>Existencia</Label><Input type="number" step="0.01" value={form.existencia} onChange={(e) => setForm({ ...form, existencia: e.target.value })} /></div>
                <div><Label>Mínimo</Label><Input type="number" step="0.01" value={form.minimo} onChange={(e) => setForm({ ...form, minimo: e.target.value })} /></div>
                <div><Label>Unidad</Label><Input value={form.unidad} onChange={(e) => setForm({ ...form, unidad: e.target.value })} /></div>
              </div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button><Button onClick={save}>Guardar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      {bajoStock.length > 0 && (
        <Card className="border-amber-500">
          <CardContent className="p-4 flex items-center gap-3 text-sm">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <div>
              <div className="font-bold">{bajoStock.length} insumo(s) en stock bajo</div>
              <div className="text-muted-foreground text-xs">{bajoStock.map((i) => i.nombre).join(", ")}</div>
            </div>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow><TableHead>Insumo</TableHead><TableHead>Existencia</TableHead><TableHead>Mínimo</TableHead><TableHead>Unidad</TableHead><TableHead>Estado</TableHead><TableHead className="text-right">Acciones</TableHead></TableRow>
            </TableHeader>
            <TableBody>
              {items.map((it) => (
                <TableRow key={it.id} className={it.existencia <= it.minimo ? "bg-amber-50 dark:bg-amber-950/30" : ""}>
                  <TableCell className="font-semibold">{it.nombre}</TableCell>
                  <TableCell><Input type="number" step="0.01" defaultValue={it.existencia} onBlur={(e) => updateExistencia(it.id, e.target.value)} className="w-24" /></TableCell>
                  <TableCell>{it.minimo}</TableCell>
                  <TableCell>{it.unidad}</TableCell>
                  <TableCell>
                    {it.existencia <= it.minimo ? <span className="text-amber-600 text-xs font-bold">BAJO</span> : <span className="text-emerald-600 text-xs font-bold">OK</span>}
                  </TableCell>
                  <TableCell className="text-right"><Button size="sm" variant="ghost" onClick={() => api.delete(`/inventario/${it.id}`).then(load)}>Desactivar</Button></TableCell>
                </TableRow>
              ))}
              {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">Sin insumos</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
